/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import { graphql } from 'gatsby'

// Components
import SEO from 'components/SEO'
import Layout from 'components/shared/Layout'
import Hero from 'components/shared/Hero'
import AllPartners from 'components/shared/AllPartners'

export const pageQuery = graphql`
  query($wordpress_id: Int) {
    page: wordpressPage(wordpress_id: { eq: $wordpress_id }) {
      ...PartnersFrag
    }
  }
`

const PageTemplate = ({
  data: {
    page: { path, acf, yoast_meta: yoast },
  },
}) => {
  return (
    <Layout>
      <SEO
        yoast={yoast}
        path={path}
        image={{ url: acf.banner.image.localFile && acf.banner.image.localFile.childImageSharp.openGraph.src }}
      />

      <Hero small className="mb-lg-5" content={acf.banner} backUrl="/partners-en-oplossingen" />

      <AllPartners className="py-5" />

    </Layout>
  )
}

export default PageTemplate
